<div *ngIf="!existeCadastro" class="row justify-content-center text-center">

    <div class="col-12 mb-3">
        <div class="user-icon-container m-auto">
            <i class="hgi hgi-stroke hgi-user-circle"></i>
        </div>
    </div>

    <div class="col-12 mb-3">
        <h1>Crie sua conta</h1>
        <p class="text-muted mb-0">
            Por favor, preencha os campos como solicitados
        </p>
    </div>

    <div *ngIf="porcentagem > 0" class="col-12">
        <div class="progress-bar">
            <div class="progress" [style.width.%]="porcentagem"></div>
        </div>
    </div>
</div>